import React, { useRef, useState } from "react";
import CallToAction from "@/components/catalog/CallToAction";
import Flicking from "@egjs/react-flicking";
import AnchorChip from "@/components/lib/AnchorChip";
import ScreeningCard from "../lib/ScreeningCard";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";
import { useProjections } from "../../_actions/eventsActions";
import format from "date-fns/format";
import * as Text from "@/components/text";

export default function TvTour() {
  const flickingRef = useRef(null);
  const [indexFlicking, setIndexFlicking] = useState(0);
  const handleChangeIndex = (index) => {
    flickingRef.current.moveTo(index);
  };
  const formatOptions = {
    day: "2-digit",
    month: "short",
  };
  const today = new Date();
  const weekDays = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];

  const {
    data: projections,
    error: projectionsError,
    loading: projectionsLoading,
  } = useProjections({
    tv_screenings: {
      date: {
        $notNull: true,
        $gte: format(today, "yyy-MM-dd") + "T06:00:00.000Z",
      },
    },
  });

  let dates = [];
  projections?.data?.map((projection) => {
    if (
      new Date(
        projection?.attributes?.tv_screenings[0]?.date
      ).toLocaleDateString("en-us", { month: "short", day: "numeric" }) ==
      today.toLocaleDateString("en-us", { month: "short", day: "numeric" })
    ) {
      dates.push("Hoy");
    } else {
      dates.push(
        new Date(
          projection?.attributes?.tv_screenings[0]?.date
        ).toLocaleDateString("es-ES", formatOptions)
      );
    }
  });

  const scrollToComponent = (id) => {
    const goTo = document.getElementById(id);

    if (goTo) {
      goTo.scrollIntoView({ behavior: "smooth" });
    }
  };
  dates = [...new Set(dates)];

  return (
    <div>
      <Text.Noun>
        Del 10 al 22 de noviembre por Canal 22 y MX Nuestro Cine.
      </Text.Noun>
      <div className="flex items-center justify-between w-full h-full mt-8">
        <button
          onClick={() => {
            indexFlicking - 1 <= 0
              ? setIndexFlicking(0)
              : setIndexFlicking(indexFlicking - 1);
            handleChangeIndex(indexFlicking);
            scrollToComponent(dates[indexFlicking - 1]);
          }}
          className="hidden mr-3 lg:block"
        >
          <ArrowLeftIcon className="w-4 h-4" />
        </button>
        <Flicking
          ref={flickingRef}
          moveType="freeScroll"
          className="items-center w-full py-2"
          bound={true}
          align="prev"
          viewportTag="div"
          cameraTag="div"
        >
          {dates.map((date, i) => (
            <>
              <div
                key={i}
                className="px-0.5"
                onClick={() => {
                  setIndexFlicking(i);
                  handleChangeIndex(indexFlicking);
                  scrollToComponent(date);
                }}
              >
                <AnchorChip active={indexFlicking === i}>{date}</AnchorChip>
              </div>
            </>
          ))}
        </Flicking>

        <button
          onClick={() => {
            indexFlicking + 1 >= dates.length - 1
              ? setIndexFlicking(dates.length - 1)
              : setIndexFlicking(indexFlicking + 1);
            handleChangeIndex(indexFlicking);
            scrollToComponent(dates[indexFlicking + 1]);
          }}
          className="hidden ml-3 lg:block"
        >
          <ArrowRightIcon className="w-4 h-4" />
        </button>
      </div>
      {projections?.data.length
        ? projections.data.map((projection, i) => (
            <>
              {new Date(
                projections?.data[i - 1]?.attributes?.tv_screenings?.[0]?.date
              ).toLocaleDateString("es-ES", formatOptions) !=
              new Date(
                projection?.attributes?.tv_screenings?.[0]?.date
              ).toLocaleDateString("es-ES", formatOptions) ? (
                <div key={projection?.id}>
                  <ScreeningCard
                    projection={projection}
                    formatOptions={formatOptions}
                    today={today}
                    weekDays={weekDays}
                    allProjections={projections?.data.slice(i)}
                  />
                </div>
              ) : null}
            </>
          ))
        : null}

      {/* <CallToAction /> */}
    </div>
  );
}
